export const Distribution = {
  ONE_TIME: 'one-time',
  PERIODICAL: 'periodical'
}

export const Level = {
  UNKNOWN: 'unknown',
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high'
}

export const Levels = [
  Level.UNKNOWN,
  Level.LOW,
  Level.MEDIUM,
  Level.HIGH
]

export const SoilLayers = {
  MINIMUM: 1,
  MAXIMUM: 10 // Infinity
}

export const SimulationMessageType = {
  SIMULATION_ERROR: 'sim-error',
  SERVER_ERROR: 'handle-error',
  DATA: 'data'
}

// TODO: Change this URL to something configurable
export const SimulationURL = 'wss://nleach.dev.yard.yara.com/simulation'

export const SimulationTimeoutTime = 200

export default {
  Distribution,
  Level,
  Levels,
  SimulationMessageType,
  SimulationURL,
  SimulationTimeoutTime
}
